<template>
  <div>
    <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="4000"
      controls
      indicators
      background="#ababab"
      img-width="1024"
      img-height="350"
      style="text-shadow: 1px 1px 2px #333"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
      class="estiloCarrusel"
    >
      <!-- Text slides with image -->
      <b-carousel-slide>
        <template #img>
          <img
            class="d-block img-fluid w-100"
            style="object-fit: cover;"
            width="1024"
            height="350"
            :src="imgUno"
            alt="image slot"
          />
        </template>
      </b-carousel-slide>

      <!-- Slides with custom text -->
      <b-carousel-slide>
        <template #img>
          <img
            class="d-block img-fluid w-100"
            width="1024"
            height="350"
            :src="imgDos"
            alt="image slot"
          />
        </template>
      </b-carousel-slide>

      <!-- Slides with image only -->
      <b-carousel-slide>
        <template #img>
          <img
            class="d-block img-fluid w-100"
            width="1024"
            height="350"
            :src="imgTres"
            alt="image slot"
          />
        </template>
      </b-carousel-slide>

      <!-- Slides with img slot -->
      <!-- Note the classes .d-block and .img-fluid to prevent browser default image alignment -->
      <b-carousel-slide>
        <template #img>
          <img
            class="d-block img-fluid w-100"
            width="1024"
            height="350"
            :src="imgCuatro"
            alt="image slot"
          />
        </template>
      </b-carousel-slide>

      <!-- Slide with blank fluid image to maintain slide aspect ratio -->
      <b-carousel-slide>
        <template #img>
          <img
            class="d-block img-fluid w-100"
            width="1024"
            height="350"
            :src="imgCinco"
            alt="image slot"
          />
        </template>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>
<script>
export default {
  data: () => ({
    slide: 0,
    sliding: null,
    //Imagenes que se muestran en el carrusel, se pueden eliminar o añadir mas imagenes.
    imgUno: require("../../assets/img/carrusel/1.png"),
    imgDos: require("../../assets/img/carrusel/dos2.jpg"),
    imgTres: require("../../assets/img/carrusel/dos2.1.jpg"),
    imgCuatro: require("../../assets/img/carrusel/dos2.2.jpg"),
    imgCinco: require("../../assets/img/carrusel/portada.jpg"),
  }),
  methods: {
    insertarRuta(ruta) {
      this.$router.push(ruta);
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
  },
};
</script>
<style>
.carousel-item img {
  height: 350px;
  object-fit: cover;
}

.estiloCarrusel {
  cursor: pointer;
}

@media screen and (max-width: 960px) {
  .carousel-item img {
    height: 250px;
    object-fit: cover;
  }
}
</style>
